class Filter
{
    constructor()
    {
        this.keys = new Map();
    }
    
    setKey(column, value)
    {
        this.keys.set(column, value);
    }
    
    apply(powerplants)
    {
        powerplants.forEach(pp => pp.isDisplayed(true));
        this.keys.forEach((value, column) => {
            if(value !== null) {
                switch(column) {
                    case 'status':
                        powerplants.forEach(pp => {
                            if(pp.getStatus() !== value) pp.isDisplayed(false);
                        });
                        break;
                    case 'step':
                        powerplants.forEach(pp => {
                            if(pp.getStep() !== value) pp.isDisplayed(false);
                        });
                        break;
                    case 'name':
                        powerplants.forEach(pp => {
                            if(!pp.getName().toLowerCase().includes(value.toLowerCase())) pp.isDisplayed(false);
                        });
                        break;
                    case 'safety':
                        powerplants.forEach(pp => {
                            if(pp.getWindSafety() !== value) pp.isDisplayed(false);
                        });
                        break;
                    case 'warning':
                        powerplants.forEach(pp => {
                            if(pp.getWarnings().filter(w => w[0] === value).length === 0) pp.isDisplayed(false);
                        });
                        break;
                    case 'app_id':
                        powerplants.forEach(pp => {
                            if(pp.getAppId() !== value) pp.isDisplayed(false);
                        });
                        break;
                    case 'percent_auto':
                        powerplants.forEach(pp => {
                            if(pp.getPercentAuto() < value) pp.isDisplayed(false);
                        });
                        break;
                    default:
                        break;
                }
            }
        });
    }
}

export default Filter;